<div class="page">
  <div class="titulo-pagina">
    <h2>Nossas Unidades</h2>
    <p>Confira abaixo os endereços e canais de atendimento de cada unidade.</p>
  </div>
  <div class="cards-grid">
    <div class="unidade-card" *ngFor="let unidade of unidades">
      <!-- BARRA SUPERIOR -->
      <div class="top-bar">LOCALIZAÇÃO DA UNIDADE</div>

      <!-- MAPA -->
      <div class="map-container">
        <iframe
          [src]="gerarMapa(unidade.endereco)"
          loading="lazy"
          allowfullscreen
        >
        </iframe>
      </div>

      <!-- CONTEÚDO -->
      <div class="card-content">
        <div class="status">Localização verificada</div>

        <h3>{{ unidade.nome }}</h3>

        <div class="section">
          <div class="label">Endereço</div>
          <div class="value">
            {{ unidade.endereco }} <br />
            CEP {{ unidade.cep }}
          </div>
        </div>

        <!-- BOTÕES MAIS DESCRITIVOS -->
        <div class="botoes">
          <button
            *ngFor="let contato of unidade.contatos"
            class="btn-contato"
            (click)="
              contato.tipo === 'ligacao'
                ? ligar(contato.numero)
                : abrirWhatsapp(contato.numero)
            "
          >
            <mat-icon>
              {{ contato.tipo === "ligacao" ? "call" : "chat" }}
            </mat-icon>

            <div class="texto-botao">
              <span class="titulo-botao">
                {{
                  contato.tipo === "ligacao"
                    ? "Ligar para a unidade"
                    : "Conversar pelo WhatsApp"
                }}
              </span>
              <span class="numero-botao">
                {{ contato.numero }}
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
